<template>
    <div>
        <CCard>
            <CCardBody>
                <v-toolbar flat color="white">
                    <v-toolbar-title>فاکتور فروش</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="confirmDialog" max-width="400px">
                        <v-card>
                            <v-card-text class="pb-0">
                                <v-container class="pb-0">
                                    <p>آیا از این کار اطمینان دارید؟</p>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <CButton color="danger" class="mb-2 ml-2 text-white"
                                         @click="confirmDialog = false">
                                    خیر
                                </CButton>
                                <CButton color="primary" class="mb-2 ml-2 text-white"
                                         @click="makeIsSent">
                                    بلی
                                </CButton>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="returnDialog" max-width="800px">
                        <v-card>
                            <v-card-text class="pb-0">
                                <v-container class="pb-0">
                                    <h2>بازگشت از فروش</h2>
                                    <CAlert color="primary" v-if="returnMessage !== ''">{{ returnMessage }}</CAlert>
                                    <div v-if="returnMessage == ''">
                                        <CButton color="success" class="text-white mb-2 ml-2" @click="returnSelectAll()">
                                            انتخاب کل سفارش
                                        </CButton>                                    
                                        <table class="table table-hover">
                                            <tr>
                                                <th>نام کالا</th>
                                                <th>تعداد</th>
                                            </tr>
                                            <tr v-for="(item, index) in returnOutputs" :key="index">
                                                <td>{{ item.product_name }}</td>
                                                <td><input type="number" v-model="item.qty_return" class="form-control" :class="index" placeholder="" min="0" :max="item.qty" style="width:100px;"></td>
                                            </tr>
                                        </table>
                                    </div>

                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <CButton color="danger" class="mb-2 ml-2 text-white" @click="returnSend()" v-if="returnMessage == ''">
                                    ارسال
                                </CButton>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-toolbar>
                <CRow>
                    <CCol sm="3">
                        <CInput
                                label="شناسه فاکتور فروش"
                                v-model="InvoiceIdText"
                                @keypress="isNumber($event)"
                                v-hotkey="keymap"
                                dir="ltr"
                        />
                    </CCol>
                    <CCol sm="3">
                        <CInput
                                label="شماره سفارش"
                                v-model="OrderCodeText"
                                @keypress="isNumber($event)"
                                v-hotkey="keymap"
                                dir="ltr"
                        />
                    </CCol>                    
                    <CCol sm="3">
                        <CInput
                                label="بارکد کالا"
                                v-model="BarcodeText"
                                @keypress="isNumber($event)"
                                v-hotkey="keymap"
                                dir="ltr"
                        />
                    </CCol>                    
                    <CCol sm="3">
                        <CButton color="primary" class="text-white mt-7" @click="invoiceSearch">
                            جستجو
                        </CButton>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> اطلاعات فاکتور </strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="6">
                                            <label>شناسه فاکتور: <b>{{invoiceInfo.invoice_id}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>شماره سفارش: <b>{{invoiceInfo.order_code}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>تاریخ فاکتور: <b>{{convertDateToJDate(invoiceInfo.invoice_date)}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>شماره فاکتور: <b>{{invoiceInfo.invoice_code}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>شخص: <b>{{invoiceInfo.contact_id}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>شماره مشتری: <b>{{invoiceInfo.customer_id}}</b></label>
                                        </CCol>                                        
                                        <CCol sm="6">
                                            <label>دسته بندی فاکتور: <b>{{invoiceInfo.invoice_category_name}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>کلیدواژه ها: <b>{{invoiceInfo.tags}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>جمع کل: <b>{{ invoiceInfo.total_price | currency('', 0, { symbolOnLeft: false })}} ریال</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>سود این فاکتور: <b>{{ invoiceInfo.profit | currency('', 0, { symbolOnLeft: false })}} ریال</b></label>
                                        </CCol>                                        
                                        <CCol sm="6">
                                            <label>نحوه ارسال: <b>{{invoiceInfo.shipping_type_name}}</b></label>
                                        </CCol>
                                        <CCol sm="6">
                                            <label>تاریخ و زمان تحویل: <b>{{convertDateToJDateWD(invoiceInfo.delivery_date)}} {{invoiceInfo.delivery_time}}</b></label>
                                        </CCol>



                                        <CCol sm="6">
                                          <label>نحوه تحویل: <b>{{invoiceInfo.sent_type_label}}</b></label>
                                        </CCol>

                                        <CCol sm="6">
                                          <label>نام پیک برای تحویل: <b>{{invoiceInfo.delivery_contact}}</b></label>
                                        </CCol>

                                        <CCol sm="6">
                                            <label>جمع آوری شده: 
                                                <b v-if="invoiceInfo.is_collected === '1'">بله</b>
                                                <b v-else>خیر</b>                                               
                                            </label>                                      
                                        </CCol>
                                        <CCol sm="6">
                                            <label>بسته بندی شده: 
                                                <b v-if="invoiceInfo.is_packed === '1'">بله</b>
                                                <b v-else>خیر</b>                                               
                                            </label>                                      
                                        </CCol>
                                        <CCol sm="6">
                                            <label>ارسال شده: 
                                                <b v-if="invoiceInfo.is_sent=== '1'">بله</b>
                                                <b v-else>خیر</b>                                               
                                            </label>                                      
                                        </CCol>                                        

                                        <CCol sm="6">
                                            <label>فایل: 
                                                <a v-if="invoiceInfo.attachment != null" v-bind:href="'https://api.erp.masterkala.com/1.0.0/tools/images/' + invoiceInfo.attachment" target="_blank">کلیک کنید.</a>
                                                <b v-else>ندارد!</b>  
                                            </label>
                                        </CCol>                                                                                                                                                                
                                        <CCol sm="12">
                                            <label>اطلاعات پستی: <br /><b v-html="invoiceInfo.address"></b></label>
                                        </CCol>
                                     
                                        <CCol sm="12">

                                            <CButton color="info" class="text-white mb-2 ml-2" @click="showReturnDialog()">
                                                بازگشت از فروش
                                            </CButton>      

                                            <CButton color="warning" class="text-white mb-2 ml-2" @click="getInvoicePdf(5)">
                                                چاپ پیش نمایش فاکتور
                                            </CButton>

                                            <CButton color="danger" class="text-white mb-2 ml-2" @click="getInvoicePdf(2)">
                                              چاپ فاکتور
                                            </CButton>

                                          <CButton color="success" class="text-white mb-2 ml-2" @click="goToBlankRoute('/sell/outputs/'+invoiceInfo.invoice_id)">
                                                مشاهده اقلام خروجی
                                            </CButton>
                                            
                                            <CButton v-if="invoiceInfo.is_sent !== '1'" color="info" class="text-white mb-2 ml-2" @click="confirmDialog=true">
                                                ثبت ارسال شد!
                                            </CButton>     

                                            <CButton v-if="invoiceInfo.is_sent !== '1'" color="danger" class="text-white mb-2 ml-2" @click="cancelInvoice()">
                                                لغو سفارش
                                            </CButton>

                                            <CButton color="info" class="text-white mb-2 ml-2" @click="addNewRevenueDialogShow = true">
                                              ثبت دریافتی جدید
                                            </CButton>

                                        </CCol>
                                    </CRow>
                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>

                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> چک کردن بارکدها </strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="1" v-for="(item, index) in invoiceInfo.barcode_all" :key="index">                                            
                                            <input type="text" v-model="invoiceInfo.barcode_all[index]" class="form-control" :class="index" placeholder=""  >         
                                                                             
                                        </CCol>                                        
                                    </CRow>
                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>       

                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> اقلام </strong>
                                </CCardHeader>
                                <CCardBody>
                                    <v-data-table
                                            :headers="productItemTableHeaders"
                                            :items="invoiceInfo.outputs"
                                            :hide-default-footer="true"
                                            :disable-pagination="true"
                                            sort-by="output_id"
                                            class="elevation-1">
                                        <template v-slot:item="{item,index}">
                                            <tr :class="{ info: checkBarcodeExist(item.barcode_list) }">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ item.product_name }}</td>
                                                <td>{{ item.product_model }}</td>
                                                <td>{{ item.barcode_string }}</td>
                                                <td>{{ item.qty }}</td>
                                                <td>{{ item.unit_price | currency('', 0, { symbolOnLeft: false })}} ریال</td>
                                                <td>{{ item.qty * item.unit_price | currency('', 0, { symbolOnLeft: false })}} ریال</td>
                                                <td>{{ item.profit | currency('', 0, { symbolOnLeft: false })}} ریال</td>
                                                <td>{{ item.sell_price | currency('', 0, { symbolOnLeft: false })}} ریال</td>
                                            </tr>

                                            <tr  v-if="index == invoiceInfo.outputs.length-1">
                                              <td></td>
                                              <td>جمع</td>
                                              <td></td>
                                              <td></td>
                                              <td>{{ invoiceInfo.total_count }}</td>
                                              <td></td>
                                              <td colspan="2">{{ invoiceInfo.total_price | currency('', 0, { symbolOnLeft: false })}} ریال</td>
                                              <td></td>
                                            </tr>

                                        </template>
                                    </v-data-table>
                                    <v-spacer></v-spacer>
                                    <v-data-table
                                            :headers="totalItemTableHeaders"
                                            :items="invoiceInfo.totals"
                                            :hide-default-footer="true"
                                            :disable-pagination="true"
                                            sort-by="sort_order"
                                            class="elevation-1" style="margin-top:20px;">
                                        <template v-slot:item="{item}">
                                            <tr>
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.total_category_name }}</td>
                                                <td>{{ item.price | currency('', 0, { symbolOnLeft: false })}} ریال</td>
                                            </tr>
                                        </template>
                                    </v-data-table>

                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>           


                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong> تراکنش ها </strong>
                                </CCardHeader>
                                <CCardBody>
                                    <v-data-table
                                            :headers="revenuesTableHeaders"
                                            :items="invoiceInfo.revenues"
                                            :hide-default-footer="true"
                                            :disable-pagination="true"
                                            sort-by="revenue_id"
                                            class="elevation-1">
                                        <template v-slot:item="{item}">
                                            <tr>
                                                <td>{{ item.revenue_id }}</td>
                                                <td>{{ item.reference_id }}</td>
                                                <td>{{ item.price | currency('', 0, { symbolOnLeft: false })}} ریال</td>
                                                <td>{{ convertDateToJDate(item.revenue_date) }}</td>
                                                <td>{{ item.account_name }}</td>
                                                <td>{{ item.revenue_category_name }}</td>
                                                <td>{{ item.description }}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>


                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>    

                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong>حواله های حساب</strong>
                                </CCardHeader>
                                <CCardBody>
                                    <v-data-table
                                            :headers="draftsTableHeaders"
                                            :items="invoiceInfo.drafts"
                                            :hide-default-footer="true"
                                            :disable-pagination="true"
                                            sort-by="draft_id"
                                            class="elevation-1">
                                        <template v-slot:item="{item}">
                                            <tr>
                                                <td>{{ convertDateToJDateWD(item.doc_date) }}</td>
                                                <td>{{ item.draft_id }}</td>
                                                <td>{{ item.from_type_name }}</td>
                                                <td>{{ item.from_name }}</td>
                                                <td>{{ item.to_type_name }}</td>
                                                <td>{{ item.to_name }}</td>
                                                <td>{{ item.price | currency('', 0, { symbolOnLeft: false }) }} ریال</td>
                                                <td>{{ item.comment }}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>

                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>                    

                <CRow>
                    <CCol md="12">
                        <CCollapse :show="collapseInvoiceInfo" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong>تاریخچه</strong>
                                </CCardHeader>
                                <CCardBody>
                                        <v-data-table
                                                :headers="logsHeaders"
                                                :items="selectedItemLogs"
                                                sort-by="log_id"
                                                :hide-default-footer="true"
                                                :disable-pagination="true"
                                                class="elevation-1">
                                            <template v-slot:item="{item}">
                                                <tr>
                                                    <td>{{ item.log_id }}</td>
                                                    <td>{{ item.action }}</td>
                                                    <td>{{ item.user_fullname }}</td>
                                                    <td>{{ convertDateToJDate(item.set_date) }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>


                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
                </CRow>                                         

            </CCardBody>
        </CCard>

        <revenue-form class="my-5" v-model="addNewRevenueDialogShow" v-bind:invoice_id="invoiceInfo.invoice_id" v-bind:revenue_date="invoiceInfo.invoice_date" v-bind:contact_id="invoiceInfo.contact_id" v-bind:customer_id="invoiceInfo.customer_id" v-bind:price="invoiceInfo.total_price" v-bind:revenue_price="invoiceInfo.revenue_price" v-bind:accounts="categories.accounts" v-bind:categories="categories.revenueCategories" action="add" title="اضافه کردن دریافتی جدید"></revenue-form>

    </div>
</template>

<script>
    import {
        functionAction,
        getCategoryType,
        getInvoiceInfo,
        callWebservice,
        getFunction 
    } from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons';
    import moment from "moment-jalaali";
    import RevenueForm from '@/components/RevenueForm'

    export default {
        name: 'InvoiceOverallReport',
        props: {},
        iconsSet,
        components: {
          RevenueForm
        },
        methods: {
            getObjectNameById(list, key, id, extraKey) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i][key] === id) {
                        if (extraKey) {
                            return list[i].name + ' ' + list[i][extraKey]
                        }
                        return list[i].name
                    }
                }
            },
            convertDateToJDate(dt) {
                if (dt === null) {
                    return 'نامشخص'
                }
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },
            convertDateToJDateWD(dt) {
                if (dt === null) {
                    return 'نامشخص'
                }
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },            
            invoiceSearch() {                
                this.collapseInvoiceInfo = false;
                getInvoiceInfo(this.$http, this.InvoiceIdText,this.BarcodeText,this.OrderCodeText).then((resp) => {
                    this.invoiceInfo = resp;
                    this.collapseInvoiceInfo = true;
                    this.InvoiceIdText = this.invoiceInfo.invoice_id;

                    getFunction(this.$http, 'logs', 0, 1000, 'name', 'desc', {
                        "code": "invoice",
                        "code_id": this.InvoiceIdText
                    }).then((resp) => {
                        this.selectedItemLogs = resp.list
                    })  
                                        
                }, (resp) => {
                    
                    this.$toasted.show(resp.body.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                    });
                })

              
            },
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            barcode_all_notempty : function(){
                var retArr = [];
                for (var j = 0; j < this.invoiceInfo.barcode_all.length; j++) {
                    if (this.invoiceInfo.barcode_all[j] != "") {
                        retArr.push(this.invoiceInfo.barcode_all[j]); 
                    }
                }
                return retArr;
            },
            goToBlankRoute(routeName) {
                let routeData = this.$base_url  + routeName;
                window.open(routeData, '_blank');
            },              
            checkBarcodeExist(bList){
                var vAll = this.barcode_all_notempty();

                if(bList.length === 0 || vAll.length === 0) return false;
                //console.log("compare:");
                //console.log(vAll);
                //console.log(bList);                
                
                for (var i = 0; i < bList.length; i++) {
                    var isFind = false;
                    for (var j = 0; j < vAll.length; j++) {
                        if (bList[i] == vAll[j]) {
                            isFind = true;
                        }
                    }
                    if(!isFind) {
                        //console.log("its false!");
                        return false;
                    }
                }
                //console.log("its true!");
                return true;                
            },
            makeIsSent() {
                let editInvoices = {
                    "make_true": "1",
                    "type": "is_sent",
                    "invoice_id": this.InvoiceIdText
                }

                callWebservice(this.$http, 'invoices/changestatus',editInvoices).then((resp) => {
                    this.$toasted.show(resp.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                    });
                    this.invoiceSearch();
                    this.confirmDialog = false;
                }, (err) => {
                    this.errors = err.body.errors;
                    this.$toasted.show(err.body.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                    });
                });

            },getInvoicePdf(reportType){
                console.log(reportType);
                //console.log(this.invoices);
                var invoicesSelectedArr = [this.InvoiceIdText];

                const req = {
                    "type": reportType,
                    "invoice_ids": invoicesSelectedArr,
                };

                callWebservice(this.$http, 'invoices/getinvoicepdf', req).then((resp) => {
                    window.open(resp.fileurl, '_blank');
                    return;
                });  
                          
                    
            },showReturnDialog(){
                this.returnOutputs = [];
                this.isSelectAll = false;
                for (var i=0; i<this.invoiceInfo.outputs.length; i++) {
                    var newValue = Object.assign({}, this.invoiceInfo.outputs[i]);
                    newValue.qty_return = 0;
                    this.$set(this.returnOutputs, i, newValue)
                }                
                
                this.returnMessage = "";
                this.returnDialog = true;
            },returnSelectAll(){
                this.isSelectAll = !this.isSelectAll;
                for (var i=0; i<this.returnOutputs.length; i++) {
                    var newValue = this.returnOutputs[i];
                    newValue.qty_return = newValue.qty;
                    this.$set(this.returnOutputs, i, newValue)
                }                
            },returnSend(){
                const req = {
                    "type": "invoice",
                    "list": this.returnOutputs,
                    "invoice_id": this.InvoiceIdText,
                    "select_all": (this.isSelectAll ? "1" : "0")
                };                 
                callWebservice(this.$http, 'inputs/set_return', req).then((resp) => {

                    this.returnMessage = resp.message;
                    
                }, (err) => {
                    this.errors = err.body.errors;
                    this.$toasted.show(err.body.message, {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 3000
                    });
                });                         
            },cancelInvoice(){
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {
                    const item = {
                        "invoice_id": this.InvoiceIdText,
                        "force_remove_barcode": "1",
                        "customer_id": "",
                        "contact_id": "",
                        "invoice_category_id": "",
                        "invoice_code": "",
                        "order_code": "",
                        "total_price": "",
                        "shipping_type_id": "",
                        "address": "",
                        "tags": "",
                        "is_sent": "",
                        "invoice_date": "",
                        "attachment": ""                        
                    };               
                       
                    functionAction(this.$http, 'invoices', 'delete', item).then((resp) => {
                        if (resp.success) {
                            this.$toasted.show(resp.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                            this.invoiceSearch();
                        } else {
                            this.$toasted.show(err.body.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 5000
                            });
                        }
                    });
                }                    
            }


                    
        },
        data: () => {
            return {
                productItemTableHeaders: [
                    {text: 'ترتیب', value: 'index'},
                    {text: 'نام محصول', value: 'product_option_id'},
                    {text: 'مدل', value: 'product_model'},
                    {text: 'بارکد ها', value: 'barcode_string'},
                    {text: 'تعداد', value: 'qty'},
                    {text: 'قیمت هر واحد', value: 'unit_price'},
                    {text: 'قیمت کل', value: 'unit_price'},
                    {text: 'سود', value: 'profit'},
                    {text: 'قیمت تمام شده', value: 'sell_price'},
                ],
                totalItemTableHeaders: [
                    {text: 'شرح', value: 'name'},
                    {text: 'زیرمجموعه', value: 'total_category_id'},
                    {text: 'قیمت', value: 'price'},
                ],      
                revenuesTableHeaders: [
                    {text: 'شماره دریافتی', value: 'revenue_id'},
                    {text: 'شماره پیگیری', value: 'reference_id'},
                    {text: 'مبلغ', value: 'price'},
                    {text: 'تاریخ', value: 'revenue_date'},
                    {text: 'حساب', value: 'account_id'},
                    {text: 'زیرمجموعه', value: ''},
                    {text: 'توضیحات', value: 'description'},
                ],
                draftsTableHeaders: [
                    {text: 'تاریخ سند', value: 'doc_date'},
                    {text: 'شماره حواله', value: 'draft_id'},
                    {text: 'بدهکار:نوع', value: 'from_type'},
                    {text: 'بدهکار:شناسه', value: 'from_id'},
                    {text: 'بستانکار:نوع', value: 'to_type'},
                    {text: 'بستانکار:شناسه', value: 'to_id'},
                    {text: 'مبلغ', value: 'price'},
                    {text: 'توضیحات', value: 'comment'},
                ],                
                logsHeaders: [
                    {text: 'شناسه', value: 'log_id'},
                    {text: 'عملیات', value: 'action'},
                    {text: 'کاربر', value: 'user_fullname'},
                    {text: 'زمان', value: 'set_date'}
                ],                                          
                productCategories: [],
                InvoiceIdText: '',
                BarcodeText: '',
                OrderCodeText: '',
                invoiceInfo: {
                    barcode_all:[]
                },
                collapseInvoiceInfo: false,
                confirmDialog: false,
                returnDialog: false,
                returnMessage : "",
                returnOutputs: [],
                selectedItemLogs: [],
                isSelectAll: false,
                addNewRevenueDialogShow: false,
                categories: {
                  accounts: [],
                  revenueCategories: []
                }
            }
        },
        mounted() {
            if (this.$route.params.id) {
                if(this.$route.params.id.startsWith("oc"))
                    this.OrderCodeText = this.$route.params.id.replace("oc", "");        
                else                            
                    this.InvoiceIdText = this.$route.params.id;
                this.invoiceSearch();
            }
            getCategoryType(this.$http, 11).then((resp) => {
                this.productCategories = resp.list;
                getCategoryType(this.$http, 10).then((resp) => {
                  this.categories.revenueCategories = resp.list;
                  getFunction(this.$http, 'accounts', 0, 1000, 'sort_order', 'desc', {}).then((resp) => {
                    this.categories.accounts = resp.list;
                  });
                });
            });
        },
        computed: {
            keymap() {
                return {
                    'enter': {
                        keyup: this.invoiceSearch
                    }
                }
            }
        },
        watch: {
          addNewRevenueDialogShow: function (val) {
            if(!val) {
              this.invoiceSearch();
            }
          }

        }

    }
</script>
